import { __assign, __rest } from "tslib";
import * as React from 'react';
import clsx from 'clsx';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { default as MuiLink } from '@material-ui/core/Link';
var useStyles = makeStyles(function (theme) {
    var errorActive = theme.palette.type === 'light' ? '#992c20' : theme.palette.error.main;
    return createStyles({
        root: {},
        inherit: {
            color: 'inherit',
            '&:active, &:hover, &:active:hover': {
                color: 'inherit',
                opacity: 0.9,
            },
            '&:focus': {
                color: 'inherit',
            },
            '&[disabled]': {
                color: 'inherit',
                opacity: 0.8,
            },
        },
        secondary: {
            color: theme.palette.action.active,
            '&:active, &:hover, &:active:hover': {
                color: theme.palette.action.hover,
            },
            '&:focus': {
                color: theme.palette.action.active,
            },
            '&[disabled]': {
                color: theme.palette.text.disabled,
            },
        },
        error: {
            color: theme.palette.error.main,
            '&:active, &:hover, &:active:hover': {
                color: errorActive,
            },
            '&:focus': {
                color: theme.palette.error.main,
            },
            '&[disabled]': {
                color: theme.palette.error.main,
            },
        },
    });
});
export var Link = React.forwardRef(function (props, ref) {
    var _a;
    var classes = useStyles(props);
    var className = props.className, color = props.color, other = __rest(props, ["className", "color"]);
    return (React.createElement(MuiLink, __assign({ underline: "always", ref: ref, className: clsx(className, classes.root, (_a = {},
            _a[classes.inherit] = color === 'inherit',
            _a[classes.secondary] = color === 'secondary',
            _a[classes.error] = color === 'error',
            _a)) }, other)));
});
export default Link;
//# sourceMappingURL=Link.js.map